import React, { useState } from 'react'
const initialModalState = {
  open: false,
  selectedBank: null
}

const usePaymentMethod = () => {
  const [isResult, setIsResult] = useState(false)
  const [modalState, setModalState] = useState({ ...initialModalState })
  const handleSelectedBank = (bank) => {
    setModalState((prev) => ({
      ...prev,
      selectedBank: bank
    }))
  }
  const handleCloseModal = () => {
    setModalState({ ...initialModalState })
  }
  const handleSuccessModal = () => {
    setIsResult((prev) => !prev)
    setModalState((prev) => ({
      ...prev,
      open: false
    }))
  }
  const handleOpenModal = () => {
    setModalState({
      open: true,
      selectedBank: null
    })
  }
  function getPaymentPayload() {
    return {
      payment_method: 'virtual_account',
      virtual_account: {
        bank_code: modalState?.selectedBank?.value,
        type: 'closed'
      }
    }
  }
  return {
    isResult,
    open: modalState?.open,
    selectedBank: modalState?.selectedBank,
    openModal: handleOpenModal,
    closeModal: handleCloseModal,
    handleSelectedBank: handleSelectedBank,
    handleSuccessModal,
    getPaymentPayload
  }
}

export default usePaymentMethod
